import { Controller, Control, FieldErrors } from 'react-hook-form';
import { Label } from '@/shared/components/ui/label';
import { MultiSelectCombobox } from '@/shared/components/ui/multi-select-combobox';
import type { ProviderEditorFormData } from '../schemas';
import { useExpertise } from '../../../hooks/useTaxonomy';

type TaxonomiesSectionProps = {
  control: Control<ProviderEditorFormData>;
  errors: FieldErrors<ProviderEditorFormData>;
};

/** Expertise only — specialties/categories live in SpecialtiesCoverageSection. */
export function TaxonomiesSection({
  control,
  errors,
}: TaxonomiesSectionProps) {
  const { data: expertise = [], isLoading: expertiseLoading } = useExpertise();

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="expertiseIds" className="text-sm font-medium">
          Areas of Expertise
        </Label>
        <p className="mb-2 mt-1 text-sm text-gray-500">
          Select specific areas of expertise (e.g., Mobility Issues, Fall Prevention)
        </p>
        <Controller
          name="expertiseIds"
          control={control}
          render={({ field }) => (
            <MultiSelectCombobox
              options={expertise}
              value={field.value || []}
              onChange={field.onChange}
              placeholder="Select expertise"
              searchPlaceholder="Search expertise..."
              emptyText="No expertise options found"
              loading={expertiseLoading}
              error={errors.expertiseIds?.message}
            />
          )}
        />
      </div>
    </div>
  );
}
